import { Pipe, PipeTransform } from '@angular/core';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';

@Pipe({name: 'typeMarketSingle'})
export class MarketTypeSinglePipe implements PipeTransform {
    constructor() { }

    transform(marketType: number): string {
        switch (marketType) {
            case OrderMarketTypeEnum.Future: return 'contrato';
            case OrderMarketTypeEnum.Option: return 'opção';
            default: return 'ação';
        }
    }
}

@Pipe({name: 'typeMarketPlural'})
export class MarketTypePluralPipe implements PipeTransform {
    transform(marketType: number): string {
        switch (marketType) {
            case OrderMarketTypeEnum.Future: return 'contratos';
            case OrderMarketTypeEnum.Option: return 'opções';
            default: return 'ações';
        }
    }
}
